import { useEffect, useState } from 'react'
import { Table, Space, Pagination, Col, Row, Breadcrumb, Button, DatePicker } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { isEmpty, trim } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import {
   CONFIG_URL,
   DATE_FORMAT_CLIENT,
   DATE_FORMAT_CLIENT_PARAMS,
   getStatusBill,
   PAGE_SIZE,
   TYPE_FUND
} from '../../helpers/constants'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { Loading } from '../../common'
import moment from 'moment'
import 'moment/locale/vi'
import useWindowDimensions from '../../common/useWindowDimensions'
import { getPage, typeFund } from 'src/helpers/constants'
import TopupAdminModal from 'src/common/components/topup/TopupAdminModal'
import useModal from 'src/helpers/modal/useModal'
import { formatCurrency } from 'src/helpers/functions'
import ProductImport from './ProductImport'
import BillProduct from './BillProduct'
import locale from 'antd/es/date-picker/locale/vi_VN'
import ImagePreview, { getImageUrl } from 'src/common/components/ImagePreview'
const TYPE_SCREEN = { bill: '1', list_product: '2' }
const { RangePicker } = DatePicker

const ProductWarehouse = observer((props: any) => {
   const { stores, showWarehouse } = props
   const { t } = useTranslation()
   const { confirm } = useModal()
   const FundStore = useStore('FundStore')
   const [textSearch, set_textSearch] = useState('')
   const [type, setType] = useState(TYPE_FUND.TAT_CA)
   const { height } = useWindowDimensions()
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [isLoading, setIsLoading] = useState(false)
   const [startTime, setStartTime] = useState(moment().subtract(1, 'months'))
   const [endTime, setEndTime] = useState(moment())
   const WarehouseStore = useStore('WarehouseStore')
   const [item, setItem] = useState(null)
   const [topup, setTopup] = useState(null)
   const [sortDateDesc, setSortDateDesc] = useState(true)
   const [isTopupModalOpen, setIsTopupModalOpen] = useState(false)
   const { before, import: importValue, export: exportValue, inventory } = WarehouseStore.priceWarehouse
   // const { rows, offset, count } = FundStore.productWithStoreList
   const [visibleView, setVisibleView] = useState<any>(TYPE_SCREEN.list_product)
   const [visibleImportProduct, setVisibleImportProduct] = useState<any>(false)
   const [visibleExportProduct, setVisibleExportProduct] = useState<any>(false)
   const [visibleImportFulfiment, setVisibleImportFulfiment] = useState(false)

   useEffect(() => {
      getListData(0, {
         // text: trim(textSearch),
         // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
      })
      WarehouseStore.getTotalPrice(
         moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         stores.id
      )
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [startTime, endTime])

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage)
         const params = { offset, ...param }
         //  console.log('params', params)

         await FundStore.getProductWithStore(stores.id, params)
      } catch (error) {
         //  console.log(error)
      } finally {
         // setIsLoading(false)
      }
   }

   const onChange = (currentPage: number) => {
      getListData(currentPage - 1, { text: trim(textSearch) })
   }

   const setDetailInfo = (value: any) => {
      setItem(value)
   }

   const handleConfirm = (value: any) => {
      // console.log('handleConfirm: ', value)

      setTopup(value)
      if (value?.type === typeFund.WITHDRAW) {
         setIsTopupModalOpen(true)
      } else {
         confirm({
            title: t(GLOBAL_CLIENT.banchapnhanphieuyeucaunay),
            icon: <ExclamationCircleOutlined />,
            // content: t(GLOBAL_CLIENT.logoutDescription),
            okText: t(GLOBAL_CLIENT.apply),
            cancelText: t(GLOBAL_CLIENT.huy),
            onCancel() {},
            async onOk() {
               await FundStore.approveFund(value?.id, { reject: false })
               getListData(0, {
                  text: trim(textSearch),
                  from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
                  to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
               })
            }
         })
      }
   }

   const onRefreshList = () => {
      getListData(0, {
         text: trim(textSearch),
         from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString()
      })
   }

   const handleCloseTopup = () => {
      setIsTopupModalOpen(false)
   }
   const columns = [
      {
         title: 'SKU',
         dataIndex: 'id',
         key: 'id',
         width: 120,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'Tên sản phẩm',
         dataIndex: 'name',
         key: 'name',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.image),
         dataIndex: 'images',
         width: 80,
         key: 'images',
         render: (value: any) => {
            return value && value[0] ? (
               <ImagePreview src={getImageUrl(value[0], CONFIG_URL.IMAGE_URL)} size={64} fit="contain" />
            ) : (
               <></>
            )
         }
      },
      {
         title: 'Tồn kho',
         dataIndex: 'inventory',
         key: 'inventory',
         width: 120,
         render: (text: string, record: any) => {
            return (
               <span className="txtMax2Line">
                  <span onClick={() => showBill(record)} className="gx-link" style={{ textDecoration: 'underline' }}>
                     {text}
                  </span>
               </span>
            )
         }
      }
   ]

   const showBill = (value: any) => {
      setItem(value)
      setVisibleView(TYPE_SCREEN.bill)
      // setTimeout(() => {
      //    setVisibleDetail(true)
      // }, 500)
   }
   const showProduct = () => {
      // setDetailInfo(value)
      setVisibleView(TYPE_SCREEN.list_product)
      // setTimeout(() => {
      //    setVisibleDetail(true)
      // }, 500)
   }
   // const renderPagination = () => {
   //    if (isEmpty(rows)) {
   //       return null
   //    }

   //    return (
   //       <div className="containerPagination">
   //          <Pagination
   //             onChange={onChange}
   //             pageSize={PAGE_SIZE}
   //             current={offset / PAGE_SIZE + 1}
   //             showSizeChanger={false}
   //             total={count}
   //          />
   //       </div>
   //    )
   // }

   function onChangeTable(pagination: any, filters: any, sorter: any, extra: any) {
      // console.log('params', pagination, filters, sorter, extra)
      if (sorter.order === 'ascend') {
         setSortDateDesc(false)
      } else {
         setSortDateDesc(true)
      }
   }

   const handleRangePickerChange = (date: any) => {
      // set_dateRangerPicker(date);
      //  console.log('datee: ', date)
      setStartTime(date[0])
      setEndTime(date[1])
   }
   const handleExport = () => {
      setVisibleExportProduct(true)
   }

   const handleImport = () => {
      setVisibleImportProduct(true)
   }
   const handleImportFulfiment = () => {
      setVisibleImportFulfiment(true)
   }

   const handleImportExportOk = (isExport = false) => {
      // export main store == import fulfillment
      if (isExport && stores.name !== 'MAIN_STORE') {
         setVisibleImportFulfiment(false)
      } else if (isExport) {
         setVisibleExportProduct(false)
      } else {
         setVisibleImportProduct(false)
      }

      getListData(0)
   }
   const handleImportExportCancel = (isExport = false) => {
      // export main store == import fulfillment
      if (isExport && stores.name !== 'MAIN_STORE') {
         setVisibleImportFulfiment(false)
      } else if (isExport) {
         setVisibleExportProduct(false)
      } else {
         setVisibleImportProduct(false)
      }

      WarehouseStore.setProductsSelected([])
   }
   const renderHeader = () => {
      return (
         <Row
            className="row-container-head"
            style={{ background: '#fff', padding: 12, borderRadius: 6, marginLeft: 0, marginRight: 0 }}
         >
            <Col span={4}>
               <Col>
                  <span style={{ fontWeight: 'bold' }}>Đầu kỳ</span>
               </Col>
               <Col>
                  <span style={{ fontSize: 18, color: '#6998B9', fontWeight: 'bolder' }}>
                     {formatCurrency(before, true)}
                  </span>
               </Col>
            </Col>
            <Col span={1} style={{ alignSelf: 'center' }}>
               {/* <span style={{ fontWeight: 'bolder' }}>+</span> */}
            </Col>
            <Col span={4}>
               <Col>
                  <span style={{ fontWeight: 'bold' }}>Tổng nhập</span>
               </Col>
               <Col>
                  <span style={{ fontSize: 18, color: '#89AD88', fontWeight: 'bolder' }}>
                     {formatCurrency(importValue, true)}
                  </span>
               </Col>
            </Col>
            <Col span={1} style={{ alignSelf: 'center' }}>
               {/* <span style={{ fontWeight: 'bolder' }}>-</span> */}
            </Col>
            <Col span={4}>
               <Col>
                  <span style={{ fontWeight: 'bold' }}>Tổng xuất</span>
               </Col>
               <Col>
                  <span style={{ fontSize: 18, color: '#B87986', fontWeight: 'bolder' }}>
                     {formatCurrency(exportValue, true)}
                  </span>
               </Col>
            </Col>
            <Col span={1} style={{ alignSelf: 'center' }}>
               {/* <span style={{ fontWeight: 'bolder' }}>=</span> */}
            </Col>
            <Col span={4}>
               <Col>
                  <span style={{ fontWeight: 'bold' }}>Tồn kho</span>
               </Col>
               <Col>
                  <span style={{ fontSize: 18, color: '#3F74A1', fontWeight: 'bolder' }}>
                     {formatCurrency(inventory, true)}
                  </span>
               </Col>
            </Col>
         </Row>
      )
   }
   return visibleView == TYPE_SCREEN.list_product ? (
      <>
         <Loading isLoading={isLoading} />
         <Row>
            <Col span={24}>
               <Breadcrumb separator=">">
                  {/* <Breadcrumb.Item>Home</Breadcrumb.Item> */}
                  <Breadcrumb.Item>
                     <span className="gx-link" style={{ textDecoration: 'underline' }} onClick={() => showWarehouse()}>
                        Kho hàng
                     </span>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item className="gx-link">{stores?.name}</Breadcrumb.Item>
                  <Breadcrumb.Item>
                     <span>Danh sách sản phẩm</span>
                  </Breadcrumb.Item>
               </Breadcrumb>

               {/* <Row className="row-container-head">
                  <Col xs={24} md={12}>
                     <Input.Search
                        onSearch={handleChangeTextSearch}
                        placeholder={t(GLOBAL_CLIENT.txtSearch)}
                        allowClear
                     />
                  </Col>
                  <Col xs={24} md={12}>
                     <div className="text-right">
                        <Space>
                           {renderFilter()}
                           <Button type="primary" className="btn-add" onClick={showCreate}>
                              <i className="icon icon-add icon-in-button" />
                              {t(GLOBAL_CLIENT.create)}
                           </Button>
                        </Space>
                     </div>
                  </Col>
               </Row> */}
               <Row className="row-container-head">
                  <Col xs={24} md={12}>
                     <div className="text-left">
                        <Space>
                           {/* <RangePicker
                              allowClear={false}
                              defaultValue={[startTime, endTime]}
                              format={DATE_FORMAT_CLIENT}
                              locale={locale}
                              onChange={handleRangePickerChange}
                           /> */}
                           {/* <Button type="primary" className="btn-add" onClick={showCreate}>
                              <i className="icon icon-add icon-in-button" />

                              {t(GLOBAL_CLIENT.create)}
                           </Button> */}
                        </Space>
                     </div>
                  </Col>
                  <Col xs={24} md={12}>
                     <div className="text-right">
                        <Space>
                           <RangePicker
                              allowClear={false}
                              defaultValue={[startTime, endTime]}
                              format={DATE_FORMAT_CLIENT}
                              locale={locale}
                              onChange={handleRangePickerChange}
                           />
                        </Space>
                     </div>
                  </Col>
               </Row>
               {renderHeader()}
               <Row className="row-container-head">
                  <Col xs={24} md={12}>
                     {/* <Input.Search
                        onSearch={handleChangeTextSearch}
                        placeholder={t(GLOBAL_CLIENT.txtSearch)}
                        allowClear
                     /> */}
                  </Col>
                  <Col xs={24} md={12}>
                     {/* <div className="text-right">
                        <Space>
                           {stores.name === 'MAIN_STORE' && (
                              <>
                                 <Button onClick={handleImport}>{'Nhập hàng'}</Button>
                                 <Button onClick={handleExport}>{'Xuất hàng'}</Button>
                              </>
                           )}
                           {stores.name !== 'MAIN_STORE' && (
                              <Button onClick={handleImportFulfiment}>{'Nhập hàng'}</Button>
                           )}
                        </Space>
                     </div> */}
                  </Col>
               </Row>

               <Space className="total-items">
                  {t(GLOBAL_CLIENT.totalItems)}: {FundStore.productWithStoreList?.length}
               </Space>

               <Table
                  // scroll={{ x: 1200 }}
                  scroll={{ y: height - 280 }}
                  columns={columns}
                  dataSource={FundStore.productWithStoreList}
                  rowKey="id"
                  pagination={false}
                  onChange={onChangeTable}
               />

               {/* {renderPagination()} */}
            </Col>
         </Row>
         {isTopupModalOpen && (
            <TopupAdminModal
               isTopupModalOpen={isTopupModalOpen}
               topup={topup}
               handleCancel={handleCloseTopup}
               onRefreshList={onRefreshList}
            />
         )}
         {visibleImportProduct && (
            <ProductImport
               visible={visibleImportProduct}
               onCancel={() => handleImportExportCancel()}
               onOk={() => handleImportExportOk()}
            />
         )}
         {visibleExportProduct && (
            <ProductImport
               exportModal
               visible={visibleExportProduct}
               onCancel={() => handleImportExportCancel(true)}
               onOk={() => handleImportExportOk(true)}
            />
         )}

         {visibleImportFulfiment && (
            // export main store == import fulfillment
            <ProductImport
               fulfimentId={stores.id}
               exportModal
               visible={visibleImportFulfiment}
               onCancel={() => handleImportExportCancel(true)}
               onOk={() => handleImportExportOk(true)}
            />
         )}
      </>
   ) : (
      item && <BillProduct showWarehouse={showWarehouse} showBill={showProduct} stores={stores} bill={item} />
   )
})

export default ProductWarehouse
